import FontKeys from "./FontKeys";
import Customize from "./scenes/factory/Customize";
import Game from "./scenes/game/Game";
import Intro from "./scenes/intro/Intro";

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Intro, Game, Customize],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Intro.KEY,

  currentScene: 'Intro', //"Intro", "Game", "Customize"
  gameOver: false,
  gamePaused: false,
  gameMuted:false,
  customizerComplete:false,
  anim: null,
  jingle: null,

  level:0,
  counter:0,
  score:0,
  fuzzIndex:0,
  totalBugCount:0,
  totalBugs:0,

  fonts:
  {
    regular: FontKeys._asapregular,
    numPad: FontKeys._fontBold
  },

  graphingQuestions:
  [
      {question:"How many Fuzz Bugs do you see?", answer:"", vials:[]},
      {question:"How many ~ Fuzz Bugs are there?", answer:"", vials:[]},
      {question:"What is the combined number of ~ and - Fuzz Bugs?", answer:"", vials:[]},
      {question:"How many more ~ Fuzz Bugs are there than - Fuzz Bugs?", answer:"", vials:[]},
      {question:"How many fewer ~ Fuzz Bugs are there than - Fuzz Bugs?", answer:"", vials:[]},
      {question:"How many fewer ~ Fuzz Bugs are there than - Fuzz Bugs?", answer:"", vials:[]}
  ],

  fuzzStencil: "",
  fuzzStencil_Color: "",
  fuzzStencil_Name: "",
  fuzzColor: "",
  fuzzColor_Name: "",
  customFuzzbug: false,
  customReplacementID: 1,
  customReplacementColor: "",

  fuzzColors: [
      {name:"Black", color:"383334"},
      {name:"White", color:"f2eddf"},
      {name:"Red", color:"ea3b2d"},
      {name:"Green", color:"a6dd10"},
      {name:"Blue", color:"137ece"},
      {name:"Orange", color:"ef8511"},
      {name:"Pink", color:"e9187e"},
      {name:"Purple", color:"a245ce"},
      {name:"Yellow", color:"f4ce11"},
      {name:"Brown", color:"873700"}
  ]
};
